/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateLLMProjectInput = {
  id?: string | null,
  name: string,
  status: string,
  description?: string | null,
  stripeCustomerId?: string | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier: number,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode: boolean,
  maintenanceModeMessage?: string | null,
  loadBalancingMode: string,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt?: string | null,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
};

export type ModelLLMProjectConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  stripeCustomerId?: ModelIDInput | null,
  newCustomerTokenCount?: ModelIntInput | null,
  cacheResponsesForSeconds?: ModelIntInput | null,
  loadSheddingTier?: ModelIntInput | null,
  newCustomerLoadSheddingTier?: ModelIntInput | null,
  maintenanceMode?: ModelBooleanInput | null,
  maintenanceModeMessage?: ModelStringInput | null,
  loadBalancingMode?: ModelStringInput | null,
  piiRedactionScope?: ModelStringInput | null,
  systemInstructions?: ModelStringInput | null,
  piiScope?: ModelStringInput | null,
  piiGroupId?: ModelStringInput | null,
  piiMessage?: ModelStringInput | null,
  promptBlacklist?: ModelStringInput | null,
  blacklistGroupId?: ModelStringInput | null,
  blacklistMessage?: ModelStringInput | null,
  safety?: ModelFloatInput | null,
  safetyGroupId?: ModelStringInput | null,
  safetyMessage?: ModelStringInput | null,
  strongModelGroupId?: ModelStringInput | null,
  routeModel?: ModelStringInput | null,
  trialTokensRemaining?: ModelIntInput | null,
  logfileRetentionPeriod?: ModelIntInput | null,
  callRetentionPeriod?: ModelIntInput | null,
  logInterval?: ModelStringInput | null,
  lastLogGeneratedAt?: ModelStringInput | null,
  enterpriseAllowChat?: ModelBooleanInput | null,
  enterpriseAcceptableUsePolicy?: ModelStringInput | null,
  enterpriseAccessRequestEmail?: ModelStringInput | null,
  enterpriseSupportEmail?: ModelStringInput | null,
  enterpriseDomainWhitelist?: ModelStringInput | null,
  enterpriseTokenBudget?: ModelIntInput | null,
  enterpriseTokenBudgetPeriod?: ModelStringInput | null,
  enterpriseImageUrl?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  apiCreditRemaining?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  summaryEmailPeriod?: ModelIntInput | null,
  summaryEmailAddresses?: ModelStringInput | null,
  lastSummaryEmailSentAt?: ModelStringInput | null,
  and?: Array< ModelLLMProjectConditionInput | null > | null,
  or?: Array< ModelLLMProjectConditionInput | null > | null,
  not?: ModelLLMProjectConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type ModelFloatInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type LLMProject = {
  __typename: "LLMProject",
  id: string,
  name: string,
  status: string,
  description?: string | null,
  users?: ModelLLMUserConnection | null,
  services?: ModelLLMServiceConnection | null,
  stripeCustomerId?: string | null,
  subscription?: LLMProjectSubscription | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier: number,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode: boolean,
  maintenanceModeMessage?: string | null,
  loadBalancingMode: string,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt: string,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
  updatedAt: string,
};

export type ModelLLMUserConnection = {
  __typename: "ModelLLMUserConnection",
  items:  Array<LLMUser | null >,
  nextToken?: string | null,
};

export type LLMUser = {
  __typename: "LLMUser",
  id: string,
  email: string,
  status: string,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId: string,
  project?: LLMProject | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMServiceConnection = {
  __typename: "ModelLLMServiceConnection",
  items:  Array<LLMService | null >,
  nextToken?: string | null,
};

export type LLMService = {
  __typename: "LLMService",
  id: string,
  name: string,
  status: string,
  vendor: string,
  region: string,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId: string,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
  group?: LLMGroup | null,
  createdAt: string,
  updatedAt: string,
};

export type LLMGroup = {
  __typename: "LLMGroup",
  id: string,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type LLMProjectSubscription = {
  __typename: "LLMProjectSubscription",
  id: string,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMProjectInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  description?: string | null,
  stripeCustomerId?: string | null,
  newCustomerTokenCount?: number | null,
  cacheResponsesForSeconds?: number | null,
  loadSheddingTier?: number | null,
  newCustomerLoadSheddingTier?: number | null,
  maintenanceMode?: boolean | null,
  maintenanceModeMessage?: string | null,
  loadBalancingMode?: string | null,
  piiRedactionScope?: string | null,
  systemInstructions?: string | null,
  piiScope?: string | null,
  piiGroupId?: string | null,
  piiMessage?: string | null,
  promptBlacklist?: string | null,
  blacklistGroupId?: string | null,
  blacklistMessage?: string | null,
  safety?: number | null,
  safetyGroupId?: string | null,
  safetyMessage?: string | null,
  strongModelGroupId?: string | null,
  routeModel?: string | null,
  trialTokensRemaining?: number | null,
  logfileRetentionPeriod?: number | null,
  callRetentionPeriod?: number | null,
  logInterval?: string | null,
  lastLogGeneratedAt?: string | null,
  enterpriseAllowChat?: boolean | null,
  enterpriseAcceptableUsePolicy?: string | null,
  enterpriseAccessRequestEmail?: string | null,
  enterpriseSupportEmail?: string | null,
  enterpriseDomainWhitelist?: string | null,
  enterpriseTokenBudget?: number | null,
  enterpriseTokenBudgetPeriod?: string | null,
  enterpriseImageUrl?: string | null,
  randomGroup?: number | null,
  apiCreditRemaining?: number | null,
  createdAt?: string | null,
  summaryEmailPeriod?: number | null,
  summaryEmailAddresses?: string | null,
  lastSummaryEmailSentAt?: string | null,
};

export type DeleteLLMProjectInput = {
  id: string,
};

export type CreateLLMProjectSubscriptionInput = {
  id?: string | null,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
};

export type ModelLLMProjectSubscriptionConditionInput = {
  projectId?: ModelIDInput | null,
  quantity?: ModelIntInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStartDate?: ModelStringInput | null,
  subscriptionEndDate?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionProduct?: ModelStringInput | null,
  subscriptionInterval?: ModelStringInput | null,
  subscriptionEndedAt?: ModelStringInput | null,
  subscriptionCancelAtPeriodEnd?: ModelStringInput | null,
  usageSubscriptionId?: ModelStringInput | null,
  and?: Array< ModelLLMProjectSubscriptionConditionInput | null > | null,
  or?: Array< ModelLLMProjectSubscriptionConditionInput | null > | null,
  not?: ModelLLMProjectSubscriptionConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMProjectSubscriptionInput = {
  id: string,
  projectId?: string | null,
  quantity?: number | null,
  subscriptionId?: string | null,
  subscriptionStartDate?: string | null,
  subscriptionEndDate?: string | null,
  subscriptionStatus?: string | null,
  subscriptionProduct?: string | null,
  subscriptionInterval?: string | null,
  subscriptionEndedAt?: string | null,
  subscriptionCancelAtPeriodEnd?: string | null,
  usageSubscriptionId?: string | null,
};

export type DeleteLLMProjectSubscriptionInput = {
  id: string,
};

export type CreateLLMUserInput = {
  id?: string | null,
  email: string,
  status: string,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId: string,
};

export type ModelLLMUserConditionInput = {
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  acceptedTermsOfService?: ModelBooleanInput | null,
  acceptedGDPRTerms?: ModelBooleanInput | null,
  projectId?: ModelIDInput | null,
  and?: Array< ModelLLMUserConditionInput | null > | null,
  or?: Array< ModelLLMUserConditionInput | null > | null,
  not?: ModelLLMUserConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMUserInput = {
  id: string,
  email?: string | null,
  status?: string | null,
  displayName?: string | null,
  acceptedTermsOfService?: boolean | null,
  acceptedGDPRTerms?: boolean | null,
  projectId?: string | null,
};

export type DeleteLLMUserInput = {
  id: string,
};

export type CreateLLMServiceInput = {
  id?: string | null,
  name: string,
  status: string,
  vendor: string,
  region: string,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId: string,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
};

export type ModelLLMServiceConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  body?: ModelStringInput | null,
  header?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  loadProportion?: ModelIntInput | null,
  inputTokenPricePerMillion?: ModelFloatInput | null,
  outputTokenPricePerMillion?: ModelFloatInput | null,
  groupId?: ModelIDInput | null,
  and?: Array< ModelLLMServiceConditionInput | null > | null,
  or?: Array< ModelLLMServiceConditionInput | null > | null,
  not?: ModelLLMServiceConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMServiceInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  vendor?: string | null,
  region?: string | null,
  endpoint?: string | null,
  body?: string | null,
  header?: string | null,
  projectId?: string | null,
  loadProportion?: number | null,
  inputTokenPricePerMillion?: number | null,
  outputTokenPricePerMillion?: number | null,
  groupId?: string | null,
};

export type DeleteLLMServiceInput = {
  id: string,
};

export type CreateLLMGroupInput = {
  id?: string | null,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
};

export type ModelLLMGroupConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  order?: ModelIntInput | null,
  and?: Array< ModelLLMGroupConditionInput | null > | null,
  or?: Array< ModelLLMGroupConditionInput | null > | null,
  not?: ModelLLMGroupConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMGroupInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  projectId?: string | null,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  order?: number | null,
};

export type DeleteLLMGroupInput = {
  id: string,
};

export type CreateLLMRouteRuleInput = {
  id?: string | null,
  status: string,
  projectId: string,
  name?: string | null,
  pattern?: string | null,
  patternAction?: string | null,
  threshold?: number | null,
  thresholdAction?: string | null,
  groupId?: string | null,
  order?: number | null,
};

export type ModelLLMRouteRuleConditionInput = {
  status?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  pattern?: ModelStringInput | null,
  patternAction?: ModelStringInput | null,
  threshold?: ModelIntInput | null,
  thresholdAction?: ModelStringInput | null,
  groupId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  and?: Array< ModelLLMRouteRuleConditionInput | null > | null,
  or?: Array< ModelLLMRouteRuleConditionInput | null > | null,
  not?: ModelLLMRouteRuleConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMRouteRule = {
  __typename: "LLMRouteRule",
  id: string,
  status: string,
  projectId: string,
  name?: string | null,
  pattern?: string | null,
  patternAction?: string | null,
  threshold?: number | null,
  thresholdAction?: string | null,
  groupId?: string | null,
  group?: LLMGroup | null,
  order?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMRouteRuleInput = {
  id: string,
  status?: string | null,
  projectId?: string | null,
  name?: string | null,
  pattern?: string | null,
  patternAction?: string | null,
  threshold?: number | null,
  thresholdAction?: string | null,
  groupId?: string | null,
  order?: number | null,
};

export type DeleteLLMRouteRuleInput = {
  id: string,
};

export type CreateLLMCustomerInput = {
  id?: string | null,
  name?: string | null,
  status: string,
  tokensRemaining: number,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId: string,
  loadSheddingTier: number,
  dataResidency: string,
  createdAt?: string | null,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
};

export type ModelLLMCustomerConditionInput = {
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  tokensRemaining?: ModelIntInput | null,
  lastCallMadeAt?: ModelStringInput | null,
  numberOfCallsMade?: ModelIntInput | null,
  projectId?: ModelIDInput | null,
  loadSheddingTier?: ModelIntInput | null,
  dataResidency?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enterpriseUser?: ModelBooleanInput | null,
  tokenReplenishmentAmount?: ModelIntInput | null,
  tokenReplenishmentPeriod?: ModelStringInput | null,
  lastReplenishedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCustomerConditionInput | null > | null,
  or?: Array< ModelLLMCustomerConditionInput | null > | null,
  not?: ModelLLMCustomerConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCustomer = {
  __typename: "LLMCustomer",
  id: string,
  name?: string | null,
  status: string,
  tokensRemaining: number,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId: string,
  loadSheddingTier: number,
  dataResidency: string,
  createdAt: string,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
  updatedAt: string,
};

export type UpdateLLMCustomerInput = {
  id: string,
  name?: string | null,
  status?: string | null,
  tokensRemaining?: number | null,
  lastCallMadeAt?: string | null,
  numberOfCallsMade?: number | null,
  projectId?: string | null,
  loadSheddingTier?: number | null,
  dataResidency?: string | null,
  createdAt?: string | null,
  enterpriseUser?: boolean | null,
  tokenReplenishmentAmount?: number | null,
  tokenReplenishmentPeriod?: string | null,
  lastReplenishedAt?: string | null,
};

export type DeleteLLMCustomerInput = {
  id: string,
};

export type CreateLLMCallInput = {
  id?: string | null,
  projectId: string,
  status: string,
  customerId?: string | null,
  serviceId?: string | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt?: string | null,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
};

export type ModelLLMCallConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  customerId?: ModelIDInput | null,
  serviceId?: ModelIDInput | null,
  requestHash?: ModelStringInput | null,
  messages?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  tokenCountPrompt?: ModelIntInput | null,
  tokenCountResponse?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  hash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  quality?: ModelIntInput | null,
  qualityComment?: ModelStringInput | null,
  apiKeyType?: ModelStringInput | null,
  toxicity?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  agentId?: ModelIDInput | null,
  conversationId?: ModelIDInput | null,
  timings?: ModelStringInput | null,
  and?: Array< ModelLLMCallConditionInput | null > | null,
  or?: Array< ModelLLMCallConditionInput | null > | null,
  not?: ModelLLMCallConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCall = {
  __typename: "LLMCall",
  id: string,
  projectId: string,
  status: string,
  customerId?: string | null,
  customer?: LLMCustomer | null,
  serviceId?: string | null,
  service?: LLMService | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt: string,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
  updatedAt: string,
};

export type UpdateLLMCallInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  customerId?: string | null,
  serviceId?: string | null,
  requestHash?: string | null,
  messages?: string | null,
  prompt?: string | null,
  response?: string | null,
  tokenCountPrompt?: number | null,
  tokenCountResponse?: number | null,
  createdAt?: string | null,
  hash?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  quality?: number | null,
  qualityComment?: string | null,
  apiKeyType?: string | null,
  toxicity?: string | null,
  randomGroup?: number | null,
  agentId?: string | null,
  conversationId?: string | null,
  timings?: string | null,
};

export type DeleteLLMCallInput = {
  id: string,
};

export type CreateLLMPromptInput = {
  id?: string | null,
  projectId: string,
  status: string,
  name: string,
  description?: string | null,
  prompt?: string | null,
  key: string,
};

export type ModelLLMPromptConditionInput = {
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  key?: ModelStringInput | null,
  and?: Array< ModelLLMPromptConditionInput | null > | null,
  or?: Array< ModelLLMPromptConditionInput | null > | null,
  not?: ModelLLMPromptConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMPrompt = {
  __typename: "LLMPrompt",
  id: string,
  projectId: string,
  status: string,
  name: string,
  description?: string | null,
  prompt?: string | null,
  key: string,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMPromptInput = {
  id: string,
  projectId?: string | null,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  prompt?: string | null,
  key?: string | null,
};

export type DeleteLLMPromptInput = {
  id: string,
};

export type CreateLLMCallLogFileInput = {
  id?: string | null,
  projectId: string,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status: string,
  bucket: string,
  key: string,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt?: string | null,
  randomGroup?: number | null,
};

export type ModelLLMCallLogFileConditionInput = {
  projectId?: ModelIDInput | null,
  fromDate?: ModelStringInput | null,
  toDate?: ModelStringInput | null,
  chunk?: ModelIntInput | null,
  count?: ModelIntInput | null,
  status?: ModelStringInput | null,
  bucket?: ModelStringInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  urlExpiresAt?: ModelStringInput | null,
  deleteFileAfter?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  and?: Array< ModelLLMCallLogFileConditionInput | null > | null,
  or?: Array< ModelLLMCallLogFileConditionInput | null > | null,
  not?: ModelLLMCallLogFileConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMCallLogFile = {
  __typename: "LLMCallLogFile",
  id: string,
  projectId: string,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status: string,
  bucket: string,
  key: string,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt: string,
  randomGroup?: number | null,
  updatedAt: string,
};

export type UpdateLLMCallLogFileInput = {
  id: string,
  projectId?: string | null,
  fromDate?: string | null,
  toDate?: string | null,
  chunk?: number | null,
  count?: number | null,
  status?: string | null,
  bucket?: string | null,
  key?: string | null,
  url?: string | null,
  urlExpiresAt?: string | null,
  deleteFileAfter?: string | null,
  createdAt?: string | null,
  randomGroup?: number | null,
};

export type DeleteLLMCallLogFileInput = {
  id: string,
};

export type CreateLLMAgentInput = {
  id?: string | null,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
};

export enum LLMVisibility {
  PUBLIC = "PUBLIC",
  ENTERPRISE = "ENTERPRISE",
  APPLICATION = "APPLICATION",
  ALL = "ALL",
}


export enum LLMEmailCaptureMode {
  HIDE = "HIDE",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}


export type ModelLLMAgentConditionInput = {
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  displayTheme?: ModelStringInput | null,
  cssUrl?: ModelStringInput | null,
  displayTitle?: ModelStringInput | null,
  displayStartMessageOrPrompt?: ModelStringInput | null,
  displayInitialMessageOrPrompt?: ModelStringInput | null,
  displayPromptTemplate?: ModelStringInput | null,
  displayFollowOnPrompts?: ModelStringInput | null,
  displayActions?: ModelStringInput | null,
  displayWidth?: ModelStringInput | null,
  displayHeight?: ModelStringInput | null,
  displayPlaceholder?: ModelStringInput | null,
  displayHideInitialPrompt?: ModelBooleanInput | null,
  displayShowSaveButton?: ModelBooleanInput | null,
  displayShowEmailButton?: ModelBooleanInput | null,
  displayShowCallToAction?: ModelBooleanInput | null,
  displayCallToActionButtonText?: ModelStringInput | null,
  displayCallToActionEmailAddress?: ModelStringInput | null,
  displayCallToActionEmailSubject?: ModelStringInput | null,
  displayCallToActionMustSendEmail?: ModelBooleanInput | null,
  displayScrollToEnd?: ModelBooleanInput | null,
  groupId?: ModelStringInput | null,
  data?: ModelStringInput | null,
  ragQueryLimit?: ModelIntInput | null,
  ragRankLimit?: ModelIntInput | null,
  ragIncludeCitations?: ModelBooleanInput | null,
  ragDoRerank?: ModelBooleanInput | null,
  visibility?: ModelLLMVisibilityInput | null,
  createConversationOnFirstChat?: ModelBooleanInput | null,
  customerEmailCaptureMode?: ModelLLMEmailCaptureModeInput | null,
  customerEmailCapturePlaceholder?: ModelStringInput | null,
  enableRAG?: ModelBooleanInput | null,
  enableMCP?: ModelBooleanInput | null,
  and?: Array< ModelLLMAgentConditionInput | null > | null,
  or?: Array< ModelLLMAgentConditionInput | null > | null,
  not?: ModelLLMAgentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMVisibilityInput = {
  eq?: LLMVisibility | null,
  ne?: LLMVisibility | null,
};

export type ModelLLMEmailCaptureModeInput = {
  eq?: LLMEmailCaptureMode | null,
  ne?: LLMEmailCaptureMode | null,
};

export type LLMAgent = {
  __typename: "LLMAgent",
  id: string,
  status: string,
  name: string,
  description?: string | null,
  projectId: string,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  calls?: ModelLLMCallConnection | null,
  documents?: ModelLLMAgentDocumentConnection | null,
  mcpServers?: ModelLLMAgentMCPConnection | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMCallConnection = {
  __typename: "ModelLLMCallConnection",
  items:  Array<LLMCall | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentDocumentConnection = {
  __typename: "ModelLLMAgentDocumentConnection",
  items:  Array<LLMAgentDocument | null >,
  nextToken?: string | null,
};

export type LLMAgentDocument = {
  __typename: "LLMAgentDocument",
  id: string,
  projectId: string,
  agentId: string,
  status: string,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
  createdAt: string,
  updatedAt: string,
};

export type ModelLLMAgentMCPConnection = {
  __typename: "ModelLLMAgentMCPConnection",
  items:  Array<LLMAgentMCP | null >,
  nextToken?: string | null,
};

export type LLMAgentMCP = {
  __typename: "LLMAgentMCP",
  id: string,
  projectId: string,
  agentId: string,
  status: string,
  transport?: LLMMCPTransport | null,
  sseUrl?: string | null,
  sseHeaders?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
  createdAt: string,
  updatedAt: string,
};

export enum LLMMCPTransport {
  SSE = "SSE",
  STDIO = "STDIO",
}


export type UpdateLLMAgentInput = {
  id: string,
  status?: string | null,
  name?: string | null,
  description?: string | null,
  projectId?: string | null,
  systemInstructions?: string | null,
  systemInstructionsAction?: string | null,
  displayTheme?: string | null,
  cssUrl?: string | null,
  displayTitle?: string | null,
  displayStartMessageOrPrompt?: string | null,
  displayInitialMessageOrPrompt?: string | null,
  displayPromptTemplate?: string | null,
  displayFollowOnPrompts?: string | null,
  displayActions?: string | null,
  displayWidth?: string | null,
  displayHeight?: string | null,
  displayPlaceholder?: string | null,
  displayHideInitialPrompt?: boolean | null,
  displayShowSaveButton?: boolean | null,
  displayShowEmailButton?: boolean | null,
  displayShowCallToAction?: boolean | null,
  displayCallToActionButtonText?: string | null,
  displayCallToActionEmailAddress?: string | null,
  displayCallToActionEmailSubject?: string | null,
  displayCallToActionMustSendEmail?: boolean | null,
  displayScrollToEnd?: boolean | null,
  groupId?: string | null,
  data?: string | null,
  ragQueryLimit?: number | null,
  ragRankLimit?: number | null,
  ragIncludeCitations?: boolean | null,
  ragDoRerank?: boolean | null,
  visibility?: LLMVisibility | null,
  createConversationOnFirstChat?: boolean | null,
  customerEmailCaptureMode?: LLMEmailCaptureMode | null,
  customerEmailCapturePlaceholder?: string | null,
  enableRAG?: boolean | null,
  enableMCP?: boolean | null,
};

export type DeleteLLMAgentInput = {
  id: string,
};

export type CreateLLMAgentMCPInput = {
  id?: string | null,
  projectId: string,
  agentId: string,
  status: string,
  transport?: LLMMCPTransport | null,
  sseUrl?: string | null,
  sseHeaders?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
};

export type ModelLLMAgentMCPConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  transport?: ModelLLMMCPTransportInput | null,
  sseUrl?: ModelStringInput | null,
  sseHeaders?: ModelStringInput | null,
  stdioCommand?: ModelStringInput | null,
  stdioArgs?: ModelStringInput | null,
  and?: Array< ModelLLMAgentMCPConditionInput | null > | null,
  or?: Array< ModelLLMAgentMCPConditionInput | null > | null,
  not?: ModelLLMAgentMCPConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ModelLLMMCPTransportInput = {
  eq?: LLMMCPTransport | null,
  ne?: LLMMCPTransport | null,
};

export type UpdateLLMAgentMCPInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  status?: string | null,
  transport?: LLMMCPTransport | null,
  sseUrl?: string | null,
  sseHeaders?: string | null,
  stdioCommand?: string | null,
  stdioArgs?: string | null,
};

export type DeleteLLMAgentMCPInput = {
  id: string,
};

export type CreateLLMAgentDocumentInput = {
  id?: string | null,
  projectId: string,
  agentId: string,
  status: string,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
};

export type ModelLLMAgentDocumentConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  uploader?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  ownershipAttestation?: ModelStringInput | null,
  location?: ModelStringInput | null,
  type?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  and?: Array< ModelLLMAgentDocumentConditionInput | null > | null,
  or?: Array< ModelLLMAgentDocumentConditionInput | null > | null,
  not?: ModelLLMAgentDocumentConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type UpdateLLMAgentDocumentInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  status?: string | null,
  fileName?: string | null,
  fileSize?: string | null,
  fileType?: string | null,
  uploadDate?: string | null,
  uploader?: string | null,
  lastModifiedDate?: string | null,
  ownershipAttestation?: string | null,
  location?: string | null,
  type?: string | null,
  ragSplitter?: string | null,
  ragChunkSize?: number | null,
  ragChunkOverlap?: number | null,
};

export type DeleteLLMAgentDocumentInput = {
  id: string,
};

export type CreateLLMConversationInput = {
  id?: string | null,
  projectId: string,
  agentId?: string | null,
  customerId?: string | null,
  createdAt?: string | null,
  status: string,
  title: string,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
};

export type ModelLLMConversationConditionInput = {
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  language?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  emailAddress?: ModelStringInput | null,
  thumbsupClicked?: ModelIntInput | null,
  thumbsdownClicked?: ModelIntInput | null,
  copyClicked?: ModelIntInput | null,
  emailClicked?: ModelIntInput | null,
  saveClicked?: ModelIntInput | null,
  ctaClicked?: ModelIntInput | null,
  suggestionClicked?: ModelIntInput | null,
  actionClicked?: ModelIntInput | null,
  intelligence?: ModelStringInput | null,
  and?: Array< ModelLLMConversationConditionInput | null > | null,
  or?: Array< ModelLLMConversationConditionInput | null > | null,
  not?: ModelLLMConversationConditionInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMConversation = {
  __typename: "LLMConversation",
  id: string,
  projectId: string,
  agentId?: string | null,
  customerId?: string | null,
  customer?: LLMCustomer | null,
  createdAt: string,
  status: string,
  title: string,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  calls?: ModelLLMCallConnection | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
  updatedAt: string,
};

export type UpdateLLMConversationInput = {
  id: string,
  projectId?: string | null,
  agentId?: string | null,
  customerId?: string | null,
  createdAt?: string | null,
  status?: string | null,
  title?: string | null,
  summary?: string | null,
  timezone?: string | null,
  language?: string | null,
  country?: string | null,
  region?: string | null,
  city?: string | null,
  emailAddress?: string | null,
  thumbsupClicked?: number | null,
  thumbsdownClicked?: number | null,
  copyClicked?: number | null,
  emailClicked?: number | null,
  saveClicked?: number | null,
  ctaClicked?: number | null,
  suggestionClicked?: number | null,
  actionClicked?: number | null,
  intelligence?: string | null,
};

export type DeleteLLMConversationInput = {
  id: string,
};

export type CreateLLMModelInput = {
  id?: string | null,
  status: string,
  vendor: string,
  host?: string | null,
  supported: boolean,
  name: string,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
};

export type ModelLLMModelConditionInput = {
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  host?: ModelStringInput | null,
  supported?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  modelKey?: ModelStringInput | null,
  modelKeyLatest?: ModelStringInput | null,
  inputTokenPrice?: ModelFloatInput | null,
  cachedTokenPrice?: ModelFloatInput | null,
  outputTokenPrice?: ModelFloatInput | null,
  inputTokenBatchPrice?: ModelFloatInput | null,
  outputTokenBatchPrice?: ModelFloatInput | null,
  searchCost?: ModelFloatInput | null,
  textInputSupport?: ModelBooleanInput | null,
  imageInputSupport?: ModelBooleanInput | null,
  audioInputSupport?: ModelBooleanInput | null,
  textOutputSupport?: ModelBooleanInput | null,
  imageOutputSupport?: ModelBooleanInput | null,
  audioOutputSupport?: ModelBooleanInput | null,
  thinkingSupport?: ModelBooleanInput | null,
  contextWindowTokens?: ModelIntInput | null,
  maxResponseTokens?: ModelIntInput | null,
  knowledgeCutoffDate?: ModelStringInput | null,
  lastCheckedDate?: ModelStringInput | null,
  supportedLanguages?: ModelStringInput | null,
  warningDate?: ModelStringInput | null,
  warningMessage?: ModelStringInput | null,
  deprecationDate?: ModelStringInput | null,
  deprecationMessage?: ModelStringInput | null,
  and?: Array< ModelLLMModelConditionInput | null > | null,
  or?: Array< ModelLLMModelConditionInput | null > | null,
  not?: ModelLLMModelConditionInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type LLMModel = {
  __typename: "LLMModel",
  id: string,
  status: string,
  vendor: string,
  host?: string | null,
  supported: boolean,
  name: string,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateLLMModelInput = {
  id: string,
  status?: string | null,
  vendor?: string | null,
  host?: string | null,
  supported?: boolean | null,
  name?: string | null,
  description?: string | null,
  modelKey?: string | null,
  modelKeyLatest?: string | null,
  inputTokenPrice?: number | null,
  cachedTokenPrice?: number | null,
  outputTokenPrice?: number | null,
  inputTokenBatchPrice?: number | null,
  outputTokenBatchPrice?: number | null,
  searchCost?: number | null,
  textInputSupport?: boolean | null,
  imageInputSupport?: boolean | null,
  audioInputSupport?: boolean | null,
  textOutputSupport?: boolean | null,
  imageOutputSupport?: boolean | null,
  audioOutputSupport?: boolean | null,
  thinkingSupport?: boolean | null,
  contextWindowTokens?: number | null,
  maxResponseTokens?: number | null,
  knowledgeCutoffDate?: string | null,
  lastCheckedDate?: string | null,
  supportedLanguages?: string | null,
  warningDate?: string | null,
  warningMessage?: string | null,
  deprecationDate?: string | null,
  deprecationMessage?: string | null,
};

export type DeleteLLMModelInput = {
  id: string,
};

export type ModelLLMProjectFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  description?: ModelStringInput | null,
  stripeCustomerId?: ModelIDInput | null,
  newCustomerTokenCount?: ModelIntInput | null,
  cacheResponsesForSeconds?: ModelIntInput | null,
  loadSheddingTier?: ModelIntInput | null,
  newCustomerLoadSheddingTier?: ModelIntInput | null,
  maintenanceMode?: ModelBooleanInput | null,
  maintenanceModeMessage?: ModelStringInput | null,
  loadBalancingMode?: ModelStringInput | null,
  piiRedactionScope?: ModelStringInput | null,
  systemInstructions?: ModelStringInput | null,
  piiScope?: ModelStringInput | null,
  piiGroupId?: ModelStringInput | null,
  piiMessage?: ModelStringInput | null,
  promptBlacklist?: ModelStringInput | null,
  blacklistGroupId?: ModelStringInput | null,
  blacklistMessage?: ModelStringInput | null,
  safety?: ModelFloatInput | null,
  safetyGroupId?: ModelStringInput | null,
  safetyMessage?: ModelStringInput | null,
  strongModelGroupId?: ModelStringInput | null,
  routeModel?: ModelStringInput | null,
  trialTokensRemaining?: ModelIntInput | null,
  logfileRetentionPeriod?: ModelIntInput | null,
  callRetentionPeriod?: ModelIntInput | null,
  logInterval?: ModelStringInput | null,
  lastLogGeneratedAt?: ModelStringInput | null,
  enterpriseAllowChat?: ModelBooleanInput | null,
  enterpriseAcceptableUsePolicy?: ModelStringInput | null,
  enterpriseAccessRequestEmail?: ModelStringInput | null,
  enterpriseSupportEmail?: ModelStringInput | null,
  enterpriseDomainWhitelist?: ModelStringInput | null,
  enterpriseTokenBudget?: ModelIntInput | null,
  enterpriseTokenBudgetPeriod?: ModelStringInput | null,
  enterpriseImageUrl?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  apiCreditRemaining?: ModelFloatInput | null,
  createdAt?: ModelStringInput | null,
  summaryEmailPeriod?: ModelIntInput | null,
  summaryEmailAddresses?: ModelStringInput | null,
  lastSummaryEmailSentAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProjectFilterInput | null > | null,
  or?: Array< ModelLLMProjectFilterInput | null > | null,
  not?: ModelLLMProjectFilterInput | null,
};

export type ModelLLMProjectConnection = {
  __typename: "ModelLLMProjectConnection",
  items:  Array<LLMProject | null >,
  nextToken?: string | null,
};

export type ModelStringKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelIntKeyConditionInput = {
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelLLMProjectSubscriptionFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  quantity?: ModelIntInput | null,
  subscriptionId?: ModelStringInput | null,
  subscriptionStartDate?: ModelStringInput | null,
  subscriptionEndDate?: ModelStringInput | null,
  subscriptionStatus?: ModelStringInput | null,
  subscriptionProduct?: ModelStringInput | null,
  subscriptionInterval?: ModelStringInput | null,
  subscriptionEndedAt?: ModelStringInput | null,
  subscriptionCancelAtPeriodEnd?: ModelStringInput | null,
  usageSubscriptionId?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMProjectSubscriptionFilterInput | null > | null,
  or?: Array< ModelLLMProjectSubscriptionFilterInput | null > | null,
  not?: ModelLLMProjectSubscriptionFilterInput | null,
};

export type ModelLLMProjectSubscriptionConnection = {
  __typename: "ModelLLMProjectSubscriptionConnection",
  items:  Array<LLMProjectSubscription | null >,
  nextToken?: string | null,
};

export type ModelLLMUserFilterInput = {
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  status?: ModelStringInput | null,
  displayName?: ModelStringInput | null,
  acceptedTermsOfService?: ModelBooleanInput | null,
  acceptedGDPRTerms?: ModelBooleanInput | null,
  projectId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMUserFilterInput | null > | null,
  or?: Array< ModelLLMUserFilterInput | null > | null,
  not?: ModelLLMUserFilterInput | null,
};

export type ModelLLMServiceFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  region?: ModelStringInput | null,
  endpoint?: ModelStringInput | null,
  body?: ModelStringInput | null,
  header?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  loadProportion?: ModelIntInput | null,
  inputTokenPricePerMillion?: ModelFloatInput | null,
  outputTokenPricePerMillion?: ModelFloatInput | null,
  groupId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMServiceFilterInput | null > | null,
  or?: Array< ModelLLMServiceFilterInput | null > | null,
  not?: ModelLLMServiceFilterInput | null,
};

export type ModelLLMGroupFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  order?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMGroupFilterInput | null > | null,
  or?: Array< ModelLLMGroupFilterInput | null > | null,
  not?: ModelLLMGroupFilterInput | null,
};

export type ModelLLMGroupConnection = {
  __typename: "ModelLLMGroupConnection",
  items:  Array<LLMGroup | null >,
  nextToken?: string | null,
};

export type ModelLLMRouteRuleFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  pattern?: ModelStringInput | null,
  patternAction?: ModelStringInput | null,
  threshold?: ModelIntInput | null,
  thresholdAction?: ModelStringInput | null,
  groupId?: ModelIDInput | null,
  order?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMRouteRuleFilterInput | null > | null,
  or?: Array< ModelLLMRouteRuleFilterInput | null > | null,
  not?: ModelLLMRouteRuleFilterInput | null,
};

export type ModelLLMRouteRuleConnection = {
  __typename: "ModelLLMRouteRuleConnection",
  items:  Array<LLMRouteRule | null >,
  nextToken?: string | null,
};

export type ModelLLMCustomerFilterInput = {
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  status?: ModelStringInput | null,
  tokensRemaining?: ModelIntInput | null,
  lastCallMadeAt?: ModelStringInput | null,
  numberOfCallsMade?: ModelIntInput | null,
  projectId?: ModelIDInput | null,
  loadSheddingTier?: ModelIntInput | null,
  dataResidency?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  enterpriseUser?: ModelBooleanInput | null,
  tokenReplenishmentAmount?: ModelIntInput | null,
  tokenReplenishmentPeriod?: ModelStringInput | null,
  lastReplenishedAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCustomerFilterInput | null > | null,
  or?: Array< ModelLLMCustomerFilterInput | null > | null,
  not?: ModelLLMCustomerFilterInput | null,
};

export type ModelLLMCustomerConnection = {
  __typename: "ModelLLMCustomerConnection",
  items:  Array<LLMCustomer | null >,
  nextToken?: string | null,
};

export type ModelLLMCallFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  customerId?: ModelIDInput | null,
  serviceId?: ModelIDInput | null,
  requestHash?: ModelStringInput | null,
  messages?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  response?: ModelStringInput | null,
  tokenCountPrompt?: ModelIntInput | null,
  tokenCountResponse?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  hash?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  quality?: ModelIntInput | null,
  qualityComment?: ModelStringInput | null,
  apiKeyType?: ModelStringInput | null,
  toxicity?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  agentId?: ModelIDInput | null,
  conversationId?: ModelIDInput | null,
  timings?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCallFilterInput | null > | null,
  or?: Array< ModelLLMCallFilterInput | null > | null,
  not?: ModelLLMCallFilterInput | null,
};

export type ModelLLMPromptFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  prompt?: ModelStringInput | null,
  key?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMPromptFilterInput | null > | null,
  or?: Array< ModelLLMPromptFilterInput | null > | null,
  not?: ModelLLMPromptFilterInput | null,
};

export type ModelLLMPromptConnection = {
  __typename: "ModelLLMPromptConnection",
  items:  Array<LLMPrompt | null >,
  nextToken?: string | null,
};

export type ModelLLMCallLogFileFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  fromDate?: ModelStringInput | null,
  toDate?: ModelStringInput | null,
  chunk?: ModelIntInput | null,
  count?: ModelIntInput | null,
  status?: ModelStringInput | null,
  bucket?: ModelStringInput | null,
  key?: ModelStringInput | null,
  url?: ModelStringInput | null,
  urlExpiresAt?: ModelStringInput | null,
  deleteFileAfter?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  randomGroup?: ModelIntInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMCallLogFileFilterInput | null > | null,
  or?: Array< ModelLLMCallLogFileFilterInput | null > | null,
  not?: ModelLLMCallLogFileFilterInput | null,
};

export type ModelLLMCallLogFileConnection = {
  __typename: "ModelLLMCallLogFileConnection",
  items:  Array<LLMCallLogFile | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  projectId?: ModelIDInput | null,
  systemInstructions?: ModelStringInput | null,
  systemInstructionsAction?: ModelStringInput | null,
  displayTheme?: ModelStringInput | null,
  cssUrl?: ModelStringInput | null,
  displayTitle?: ModelStringInput | null,
  displayStartMessageOrPrompt?: ModelStringInput | null,
  displayInitialMessageOrPrompt?: ModelStringInput | null,
  displayPromptTemplate?: ModelStringInput | null,
  displayFollowOnPrompts?: ModelStringInput | null,
  displayActions?: ModelStringInput | null,
  displayWidth?: ModelStringInput | null,
  displayHeight?: ModelStringInput | null,
  displayPlaceholder?: ModelStringInput | null,
  displayHideInitialPrompt?: ModelBooleanInput | null,
  displayShowSaveButton?: ModelBooleanInput | null,
  displayShowEmailButton?: ModelBooleanInput | null,
  displayShowCallToAction?: ModelBooleanInput | null,
  displayCallToActionButtonText?: ModelStringInput | null,
  displayCallToActionEmailAddress?: ModelStringInput | null,
  displayCallToActionEmailSubject?: ModelStringInput | null,
  displayCallToActionMustSendEmail?: ModelBooleanInput | null,
  displayScrollToEnd?: ModelBooleanInput | null,
  groupId?: ModelStringInput | null,
  data?: ModelStringInput | null,
  ragQueryLimit?: ModelIntInput | null,
  ragRankLimit?: ModelIntInput | null,
  ragIncludeCitations?: ModelBooleanInput | null,
  ragDoRerank?: ModelBooleanInput | null,
  visibility?: ModelLLMVisibilityInput | null,
  createConversationOnFirstChat?: ModelBooleanInput | null,
  customerEmailCaptureMode?: ModelLLMEmailCaptureModeInput | null,
  customerEmailCapturePlaceholder?: ModelStringInput | null,
  enableRAG?: ModelBooleanInput | null,
  enableMCP?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentFilterInput | null > | null,
  or?: Array< ModelLLMAgentFilterInput | null > | null,
  not?: ModelLLMAgentFilterInput | null,
};

export type ModelLLMAgentConnection = {
  __typename: "ModelLLMAgentConnection",
  items:  Array<LLMAgent | null >,
  nextToken?: string | null,
};

export type ModelLLMAgentMCPFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  transport?: ModelLLMMCPTransportInput | null,
  sseUrl?: ModelStringInput | null,
  sseHeaders?: ModelStringInput | null,
  stdioCommand?: ModelStringInput | null,
  stdioArgs?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentMCPFilterInput | null > | null,
  or?: Array< ModelLLMAgentMCPFilterInput | null > | null,
  not?: ModelLLMAgentMCPFilterInput | null,
};

export type ModelLLMAgentDocumentFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  fileName?: ModelStringInput | null,
  fileSize?: ModelStringInput | null,
  fileType?: ModelStringInput | null,
  uploadDate?: ModelStringInput | null,
  uploader?: ModelStringInput | null,
  lastModifiedDate?: ModelStringInput | null,
  ownershipAttestation?: ModelStringInput | null,
  location?: ModelStringInput | null,
  type?: ModelStringInput | null,
  ragSplitter?: ModelStringInput | null,
  ragChunkSize?: ModelIntInput | null,
  ragChunkOverlap?: ModelIntInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMAgentDocumentFilterInput | null > | null,
  or?: Array< ModelLLMAgentDocumentFilterInput | null > | null,
  not?: ModelLLMAgentDocumentFilterInput | null,
};

export type ModelLLMConversationFilterInput = {
  id?: ModelIDInput | null,
  projectId?: ModelIDInput | null,
  agentId?: ModelIDInput | null,
  customerId?: ModelIDInput | null,
  createdAt?: ModelStringInput | null,
  status?: ModelStringInput | null,
  title?: ModelStringInput | null,
  summary?: ModelStringInput | null,
  timezone?: ModelStringInput | null,
  language?: ModelStringInput | null,
  country?: ModelStringInput | null,
  region?: ModelStringInput | null,
  city?: ModelStringInput | null,
  emailAddress?: ModelStringInput | null,
  thumbsupClicked?: ModelIntInput | null,
  thumbsdownClicked?: ModelIntInput | null,
  copyClicked?: ModelIntInput | null,
  emailClicked?: ModelIntInput | null,
  saveClicked?: ModelIntInput | null,
  ctaClicked?: ModelIntInput | null,
  suggestionClicked?: ModelIntInput | null,
  actionClicked?: ModelIntInput | null,
  intelligence?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMConversationFilterInput | null > | null,
  or?: Array< ModelLLMConversationFilterInput | null > | null,
  not?: ModelLLMConversationFilterInput | null,
};

export type ModelLLMConversationConnection = {
  __typename: "ModelLLMConversationConnection",
  items:  Array<LLMConversation | null >,
  nextToken?: string | null,
};

export type ModelLLMModelFilterInput = {
  id?: ModelIDInput | null,
  status?: ModelStringInput | null,
  vendor?: ModelStringInput | null,
  host?: ModelStringInput | null,
  supported?: ModelBooleanInput | null,
  name?: ModelStringInput | null,
  description?: ModelStringInput | null,
  modelKey?: ModelStringInput | null,
  modelKeyLatest?: ModelStringInput | null,
  inputTokenPrice?: ModelFloatInput | null,
  cachedTokenPrice?: ModelFloatInput | null,
  outputTokenPrice?: ModelFloatInput | null,
  inputTokenBatchPrice?: ModelFloatInput | null,
  outputTokenBatchPrice?: ModelFloatInput | null,
  searchCost?: ModelFloatInput | null,
  textInputSupport?: ModelBooleanInput | null,
  imageInputSupport?: ModelBooleanInput | null,
  audioInputSupport?: ModelBooleanInput | null,
  textOutputSupport?: ModelBooleanInput | null,
  imageOutputSupport?: ModelBooleanInput | null,
  audioOutputSupport?: ModelBooleanInput | null,
  thinkingSupport?: ModelBooleanInput | null,
  contextWindowTokens?: ModelIntInput | null,
  maxResponseTokens?: ModelIntInput | null,
  knowledgeCutoffDate?: ModelStringInput | null,
  lastCheckedDate?: ModelStringInput | null,
  supportedLanguages?: ModelStringInput | null,
  warningDate?: ModelStringInput | null,
  warningMessage?: ModelStringInput | null,
  deprecationDate?: ModelStringInput | null,
  deprecationMessage?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelLLMModelFilterInput | null > | null,
  or?: Array< ModelLLMModelFilterInput | null > | null,
  not?: ModelLLMModelFilterInput | null,
};

export type ModelLLMModelConnection = {
  __typename: "ModelLLMModelConnection",
  items:  Array<LLMModel | null >,
  nextToken?: string | null,
};

export type CreateLLMProjectMutationVariables = {
  input: CreateLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type CreateLLMProjectMutation = {
  createLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMProjectMutationVariables = {
  input: UpdateLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type UpdateLLMProjectMutation = {
  updateLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMProjectMutationVariables = {
  input: DeleteLLMProjectInput,
  condition?: ModelLLMProjectConditionInput | null,
};

export type DeleteLLMProjectMutation = {
  deleteLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMProjectSubscriptionMutationVariables = {
  input: CreateLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type CreateLLMProjectSubscriptionMutation = {
  createLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMProjectSubscriptionMutationVariables = {
  input: UpdateLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type UpdateLLMProjectSubscriptionMutation = {
  updateLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMProjectSubscriptionMutationVariables = {
  input: DeleteLLMProjectSubscriptionInput,
  condition?: ModelLLMProjectSubscriptionConditionInput | null,
};

export type DeleteLLMProjectSubscriptionMutation = {
  deleteLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMUserMutationVariables = {
  input: CreateLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type CreateLLMUserMutation = {
  createLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMUserMutationVariables = {
  input: UpdateLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type UpdateLLMUserMutation = {
  updateLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMUserMutationVariables = {
  input: DeleteLLMUserInput,
  condition?: ModelLLMUserConditionInput | null,
};

export type DeleteLLMUserMutation = {
  deleteLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMServiceMutationVariables = {
  input: CreateLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type CreateLLMServiceMutation = {
  createLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMServiceMutationVariables = {
  input: UpdateLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type UpdateLLMServiceMutation = {
  updateLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMServiceMutationVariables = {
  input: DeleteLLMServiceInput,
  condition?: ModelLLMServiceConditionInput | null,
};

export type DeleteLLMServiceMutation = {
  deleteLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMGroupMutationVariables = {
  input: CreateLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type CreateLLMGroupMutation = {
  createLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMGroupMutationVariables = {
  input: UpdateLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type UpdateLLMGroupMutation = {
  updateLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMGroupMutationVariables = {
  input: DeleteLLMGroupInput,
  condition?: ModelLLMGroupConditionInput | null,
};

export type DeleteLLMGroupMutation = {
  deleteLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMRouteRuleMutationVariables = {
  input: CreateLLMRouteRuleInput,
  condition?: ModelLLMRouteRuleConditionInput | null,
};

export type CreateLLMRouteRuleMutation = {
  createLLMRouteRule?:  {
    __typename: "LLMRouteRule",
    id: string,
    status: string,
    projectId: string,
    name?: string | null,
    pattern?: string | null,
    patternAction?: string | null,
    threshold?: number | null,
    thresholdAction?: string | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMRouteRuleMutationVariables = {
  input: UpdateLLMRouteRuleInput,
  condition?: ModelLLMRouteRuleConditionInput | null,
};

export type UpdateLLMRouteRuleMutation = {
  updateLLMRouteRule?:  {
    __typename: "LLMRouteRule",
    id: string,
    status: string,
    projectId: string,
    name?: string | null,
    pattern?: string | null,
    patternAction?: string | null,
    threshold?: number | null,
    thresholdAction?: string | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMRouteRuleMutationVariables = {
  input: DeleteLLMRouteRuleInput,
  condition?: ModelLLMRouteRuleConditionInput | null,
};

export type DeleteLLMRouteRuleMutation = {
  deleteLLMRouteRule?:  {
    __typename: "LLMRouteRule",
    id: string,
    status: string,
    projectId: string,
    name?: string | null,
    pattern?: string | null,
    patternAction?: string | null,
    threshold?: number | null,
    thresholdAction?: string | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMCustomerMutationVariables = {
  input: CreateLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type CreateLLMCustomerMutation = {
  createLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCustomerMutationVariables = {
  input: UpdateLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type UpdateLLMCustomerMutation = {
  updateLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCustomerMutationVariables = {
  input: DeleteLLMCustomerInput,
  condition?: ModelLLMCustomerConditionInput | null,
};

export type DeleteLLMCustomerMutation = {
  deleteLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMCallMutationVariables = {
  input: CreateLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type CreateLLMCallMutation = {
  createLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCallMutationVariables = {
  input: UpdateLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type UpdateLLMCallMutation = {
  updateLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCallMutationVariables = {
  input: DeleteLLMCallInput,
  condition?: ModelLLMCallConditionInput | null,
};

export type DeleteLLMCallMutation = {
  deleteLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMPromptMutationVariables = {
  input: CreateLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type CreateLLMPromptMutation = {
  createLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMPromptMutationVariables = {
  input: UpdateLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type UpdateLLMPromptMutation = {
  updateLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMPromptMutationVariables = {
  input: DeleteLLMPromptInput,
  condition?: ModelLLMPromptConditionInput | null,
};

export type DeleteLLMPromptMutation = {
  deleteLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMCallLogFileMutationVariables = {
  input: CreateLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type CreateLLMCallLogFileMutation = {
  createLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMCallLogFileMutationVariables = {
  input: UpdateLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type UpdateLLMCallLogFileMutation = {
  updateLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMCallLogFileMutationVariables = {
  input: DeleteLLMCallLogFileInput,
  condition?: ModelLLMCallLogFileConditionInput | null,
};

export type DeleteLLMCallLogFileMutation = {
  deleteLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentMutationVariables = {
  input: CreateLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type CreateLLMAgentMutation = {
  createLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        transport?: LLMMCPTransport | null,
        sseUrl?: string | null,
        sseHeaders?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentMutationVariables = {
  input: UpdateLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type UpdateLLMAgentMutation = {
  updateLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        transport?: LLMMCPTransport | null,
        sseUrl?: string | null,
        sseHeaders?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentMutationVariables = {
  input: DeleteLLMAgentInput,
  condition?: ModelLLMAgentConditionInput | null,
};

export type DeleteLLMAgentMutation = {
  deleteLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        transport?: LLMMCPTransport | null,
        sseUrl?: string | null,
        sseHeaders?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentMCPMutationVariables = {
  input: CreateLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type CreateLLMAgentMCPMutation = {
  createLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    transport?: LLMMCPTransport | null,
    sseUrl?: string | null,
    sseHeaders?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentMCPMutationVariables = {
  input: UpdateLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type UpdateLLMAgentMCPMutation = {
  updateLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    transport?: LLMMCPTransport | null,
    sseUrl?: string | null,
    sseHeaders?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentMCPMutationVariables = {
  input: DeleteLLMAgentMCPInput,
  condition?: ModelLLMAgentMCPConditionInput | null,
};

export type DeleteLLMAgentMCPMutation = {
  deleteLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    transport?: LLMMCPTransport | null,
    sseUrl?: string | null,
    sseHeaders?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMAgentDocumentMutationVariables = {
  input: CreateLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type CreateLLMAgentDocumentMutation = {
  createLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMAgentDocumentMutationVariables = {
  input: UpdateLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type UpdateLLMAgentDocumentMutation = {
  updateLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMAgentDocumentMutationVariables = {
  input: DeleteLLMAgentDocumentInput,
  condition?: ModelLLMAgentDocumentConditionInput | null,
};

export type DeleteLLMAgentDocumentMutation = {
  deleteLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type CreateLLMConversationMutationVariables = {
  input: CreateLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type CreateLLMConversationMutation = {
  createLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    updatedAt: string,
  } | null,
};

export type UpdateLLMConversationMutationVariables = {
  input: UpdateLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type UpdateLLMConversationMutation = {
  updateLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    updatedAt: string,
  } | null,
};

export type DeleteLLMConversationMutationVariables = {
  input: DeleteLLMConversationInput,
  condition?: ModelLLMConversationConditionInput | null,
};

export type DeleteLLMConversationMutation = {
  deleteLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    updatedAt: string,
  } | null,
};

export type CreateLLMModelMutationVariables = {
  input: CreateLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type CreateLLMModelMutation = {
  createLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host?: string | null,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateLLMModelMutationVariables = {
  input: UpdateLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type UpdateLLMModelMutation = {
  updateLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host?: string | null,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type DeleteLLMModelMutationVariables = {
  input: DeleteLLMModelInput,
  condition?: ModelLLMModelConditionInput | null,
};

export type DeleteLLMModelMutation = {
  deleteLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host?: string | null,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type GetLLMProjectQueryVariables = {
  id: string,
};

export type GetLLMProjectQuery = {
  getLLMProject?:  {
    __typename: "LLMProject",
    id: string,
    name: string,
    status: string,
    description?: string | null,
    users?:  {
      __typename: "ModelLLMUserConnection",
      items:  Array< {
        __typename: "LLMUser",
        id: string,
        email: string,
        status: string,
        displayName?: string | null,
        acceptedTermsOfService?: boolean | null,
        acceptedGDPRTerms?: boolean | null,
        projectId: string,
        project?:  {
          __typename: "LLMProject",
          id: string,
          name: string,
          status: string,
          description?: string | null,
          stripeCustomerId?: string | null,
          newCustomerTokenCount?: number | null,
          cacheResponsesForSeconds?: number | null,
          loadSheddingTier: number,
          newCustomerLoadSheddingTier?: number | null,
          maintenanceMode: boolean,
          maintenanceModeMessage?: string | null,
          loadBalancingMode: string,
          piiRedactionScope?: string | null,
          systemInstructions?: string | null,
          piiScope?: string | null,
          piiGroupId?: string | null,
          piiMessage?: string | null,
          promptBlacklist?: string | null,
          blacklistGroupId?: string | null,
          blacklistMessage?: string | null,
          safety?: number | null,
          safetyGroupId?: string | null,
          safetyMessage?: string | null,
          strongModelGroupId?: string | null,
          routeModel?: string | null,
          trialTokensRemaining?: number | null,
          logfileRetentionPeriod?: number | null,
          callRetentionPeriod?: number | null,
          logInterval?: string | null,
          lastLogGeneratedAt?: string | null,
          enterpriseAllowChat?: boolean | null,
          enterpriseAcceptableUsePolicy?: string | null,
          enterpriseAccessRequestEmail?: string | null,
          enterpriseSupportEmail?: string | null,
          enterpriseDomainWhitelist?: string | null,
          enterpriseTokenBudget?: number | null,
          enterpriseTokenBudgetPeriod?: string | null,
          enterpriseImageUrl?: string | null,
          randomGroup?: number | null,
          apiCreditRemaining?: number | null,
          createdAt: string,
          summaryEmailPeriod?: number | null,
          summaryEmailAddresses?: string | null,
          lastSummaryEmailSentAt?: string | null,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    services?:  {
      __typename: "ModelLLMServiceConnection",
      items:  Array< {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    stripeCustomerId?: string | null,
    subscription?:  {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    newCustomerTokenCount?: number | null,
    cacheResponsesForSeconds?: number | null,
    loadSheddingTier: number,
    newCustomerLoadSheddingTier?: number | null,
    maintenanceMode: boolean,
    maintenanceModeMessage?: string | null,
    loadBalancingMode: string,
    piiRedactionScope?: string | null,
    systemInstructions?: string | null,
    piiScope?: string | null,
    piiGroupId?: string | null,
    piiMessage?: string | null,
    promptBlacklist?: string | null,
    blacklistGroupId?: string | null,
    blacklistMessage?: string | null,
    safety?: number | null,
    safetyGroupId?: string | null,
    safetyMessage?: string | null,
    strongModelGroupId?: string | null,
    routeModel?: string | null,
    trialTokensRemaining?: number | null,
    logfileRetentionPeriod?: number | null,
    callRetentionPeriod?: number | null,
    logInterval?: string | null,
    lastLogGeneratedAt?: string | null,
    enterpriseAllowChat?: boolean | null,
    enterpriseAcceptableUsePolicy?: string | null,
    enterpriseAccessRequestEmail?: string | null,
    enterpriseSupportEmail?: string | null,
    enterpriseDomainWhitelist?: string | null,
    enterpriseTokenBudget?: number | null,
    enterpriseTokenBudgetPeriod?: string | null,
    enterpriseImageUrl?: string | null,
    randomGroup?: number | null,
    apiCreditRemaining?: number | null,
    createdAt: string,
    summaryEmailPeriod?: number | null,
    summaryEmailAddresses?: string | null,
    lastSummaryEmailSentAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLLMProjectsQueryVariables = {
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMProjectsQuery = {
  listLLMProjects?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByLogIntervalAndLastLogGeneratedAtQueryVariables = {
  logInterval: string,
  lastLogGeneratedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByLogIntervalAndLastLogGeneratedAtQuery = {
  projectsByLogIntervalAndLastLogGeneratedAt?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByRandomGroupAndCreatedAtQueryVariables = {
  randomGroup: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByRandomGroupAndCreatedAtQuery = {
  projectsByRandomGroupAndCreatedAt?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ProjectsByRandomGroupAndSummaryEmailPeriodQueryVariables = {
  randomGroup: number,
  summaryEmailPeriod?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMProjectFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ProjectsByRandomGroupAndSummaryEmailPeriodQuery = {
  projectsByRandomGroupAndSummaryEmailPeriod?:  {
    __typename: "ModelLLMProjectConnection",
    items:  Array< {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMProjectSubscriptionQueryVariables = {
  id: string,
};

export type GetLLMProjectSubscriptionQuery = {
  getLLMProjectSubscription?:  {
    __typename: "LLMProjectSubscription",
    id: string,
    projectId?: string | null,
    quantity?: number | null,
    subscriptionId?: string | null,
    subscriptionStartDate?: string | null,
    subscriptionEndDate?: string | null,
    subscriptionStatus?: string | null,
    subscriptionProduct?: string | null,
    subscriptionInterval?: string | null,
    subscriptionEndedAt?: string | null,
    subscriptionCancelAtPeriodEnd?: string | null,
    usageSubscriptionId?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMProjectSubscriptionsQueryVariables = {
  filter?: ModelLLMProjectSubscriptionFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMProjectSubscriptionsQuery = {
  listLLMProjectSubscriptions?:  {
    __typename: "ModelLLMProjectSubscriptionConnection",
    items:  Array< {
      __typename: "LLMProjectSubscription",
      id: string,
      projectId?: string | null,
      quantity?: number | null,
      subscriptionId?: string | null,
      subscriptionStartDate?: string | null,
      subscriptionEndDate?: string | null,
      subscriptionStatus?: string | null,
      subscriptionProduct?: string | null,
      subscriptionInterval?: string | null,
      subscriptionEndedAt?: string | null,
      subscriptionCancelAtPeriodEnd?: string | null,
      usageSubscriptionId?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMUserQueryVariables = {
  id: string,
};

export type GetLLMUserQuery = {
  getLLMUser?:  {
    __typename: "LLMUser",
    id: string,
    email: string,
    status: string,
    displayName?: string | null,
    acceptedTermsOfService?: boolean | null,
    acceptedGDPRTerms?: boolean | null,
    projectId: string,
    project?:  {
      __typename: "LLMProject",
      id: string,
      name: string,
      status: string,
      description?: string | null,
      users?:  {
        __typename: "ModelLLMUserConnection",
        items:  Array< {
          __typename: "LLMUser",
          id: string,
          email: string,
          status: string,
          displayName?: string | null,
          acceptedTermsOfService?: boolean | null,
          acceptedGDPRTerms?: boolean | null,
          projectId: string,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      services?:  {
        __typename: "ModelLLMServiceConnection",
        items:  Array< {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      stripeCustomerId?: string | null,
      subscription?:  {
        __typename: "LLMProjectSubscription",
        id: string,
        projectId?: string | null,
        quantity?: number | null,
        subscriptionId?: string | null,
        subscriptionStartDate?: string | null,
        subscriptionEndDate?: string | null,
        subscriptionStatus?: string | null,
        subscriptionProduct?: string | null,
        subscriptionInterval?: string | null,
        subscriptionEndedAt?: string | null,
        subscriptionCancelAtPeriodEnd?: string | null,
        usageSubscriptionId?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      newCustomerTokenCount?: number | null,
      cacheResponsesForSeconds?: number | null,
      loadSheddingTier: number,
      newCustomerLoadSheddingTier?: number | null,
      maintenanceMode: boolean,
      maintenanceModeMessage?: string | null,
      loadBalancingMode: string,
      piiRedactionScope?: string | null,
      systemInstructions?: string | null,
      piiScope?: string | null,
      piiGroupId?: string | null,
      piiMessage?: string | null,
      promptBlacklist?: string | null,
      blacklistGroupId?: string | null,
      blacklistMessage?: string | null,
      safety?: number | null,
      safetyGroupId?: string | null,
      safetyMessage?: string | null,
      strongModelGroupId?: string | null,
      routeModel?: string | null,
      trialTokensRemaining?: number | null,
      logfileRetentionPeriod?: number | null,
      callRetentionPeriod?: number | null,
      logInterval?: string | null,
      lastLogGeneratedAt?: string | null,
      enterpriseAllowChat?: boolean | null,
      enterpriseAcceptableUsePolicy?: string | null,
      enterpriseAccessRequestEmail?: string | null,
      enterpriseSupportEmail?: string | null,
      enterpriseDomainWhitelist?: string | null,
      enterpriseTokenBudget?: number | null,
      enterpriseTokenBudgetPeriod?: string | null,
      enterpriseImageUrl?: string | null,
      randomGroup?: number | null,
      apiCreditRemaining?: number | null,
      createdAt: string,
      summaryEmailPeriod?: number | null,
      summaryEmailAddresses?: string | null,
      lastSummaryEmailSentAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMUsersQueryVariables = {
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMUsersQuery = {
  listLLMUsers?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByEmailQuery = {
  usersByEmail?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type UsersByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type UsersByProjectIdQuery = {
  usersByProjectId?:  {
    __typename: "ModelLLMUserConnection",
    items:  Array< {
      __typename: "LLMUser",
      id: string,
      email: string,
      status: string,
      displayName?: string | null,
      acceptedTermsOfService?: boolean | null,
      acceptedGDPRTerms?: boolean | null,
      projectId: string,
      project?:  {
        __typename: "LLMProject",
        id: string,
        name: string,
        status: string,
        description?: string | null,
        users?:  {
          __typename: "ModelLLMUserConnection",
          nextToken?: string | null,
        } | null,
        services?:  {
          __typename: "ModelLLMServiceConnection",
          nextToken?: string | null,
        } | null,
        stripeCustomerId?: string | null,
        subscription?:  {
          __typename: "LLMProjectSubscription",
          id: string,
          projectId?: string | null,
          quantity?: number | null,
          subscriptionId?: string | null,
          subscriptionStartDate?: string | null,
          subscriptionEndDate?: string | null,
          subscriptionStatus?: string | null,
          subscriptionProduct?: string | null,
          subscriptionInterval?: string | null,
          subscriptionEndedAt?: string | null,
          subscriptionCancelAtPeriodEnd?: string | null,
          usageSubscriptionId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        newCustomerTokenCount?: number | null,
        cacheResponsesForSeconds?: number | null,
        loadSheddingTier: number,
        newCustomerLoadSheddingTier?: number | null,
        maintenanceMode: boolean,
        maintenanceModeMessage?: string | null,
        loadBalancingMode: string,
        piiRedactionScope?: string | null,
        systemInstructions?: string | null,
        piiScope?: string | null,
        piiGroupId?: string | null,
        piiMessage?: string | null,
        promptBlacklist?: string | null,
        blacklistGroupId?: string | null,
        blacklistMessage?: string | null,
        safety?: number | null,
        safetyGroupId?: string | null,
        safetyMessage?: string | null,
        strongModelGroupId?: string | null,
        routeModel?: string | null,
        trialTokensRemaining?: number | null,
        logfileRetentionPeriod?: number | null,
        callRetentionPeriod?: number | null,
        logInterval?: string | null,
        lastLogGeneratedAt?: string | null,
        enterpriseAllowChat?: boolean | null,
        enterpriseAcceptableUsePolicy?: string | null,
        enterpriseAccessRequestEmail?: string | null,
        enterpriseSupportEmail?: string | null,
        enterpriseDomainWhitelist?: string | null,
        enterpriseTokenBudget?: number | null,
        enterpriseTokenBudgetPeriod?: string | null,
        enterpriseImageUrl?: string | null,
        randomGroup?: number | null,
        apiCreditRemaining?: number | null,
        createdAt: string,
        summaryEmailPeriod?: number | null,
        summaryEmailAddresses?: string | null,
        lastSummaryEmailSentAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMServiceQueryVariables = {
  id: string,
};

export type GetLLMServiceQuery = {
  getLLMService?:  {
    __typename: "LLMService",
    id: string,
    name: string,
    status: string,
    vendor: string,
    region: string,
    endpoint?: string | null,
    body?: string | null,
    header?: string | null,
    projectId: string,
    loadProportion?: number | null,
    inputTokenPricePerMillion?: number | null,
    outputTokenPricePerMillion?: number | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMServicesQueryVariables = {
  filter?: ModelLLMServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMServicesQuery = {
  listLLMServices?:  {
    __typename: "ModelLLMServiceConnection",
    items:  Array< {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ServicesByProjectIdQueryVariables = {
  projectId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMServiceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ServicesByProjectIdQuery = {
  servicesByProjectId?:  {
    __typename: "ModelLLMServiceConnection",
    items:  Array< {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMGroupQueryVariables = {
  id: string,
};

export type GetLLMGroupQuery = {
  getLLMGroup?:  {
    __typename: "LLMGroup",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMGroupsQueryVariables = {
  filter?: ModelLLMGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMGroupsQuery = {
  listLLMGroups?:  {
    __typename: "ModelLLMGroupConnection",
    items:  Array< {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GroupsByProjectIdQueryVariables = {
  projectId: string,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMGroupFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type GroupsByProjectIdQuery = {
  groupsByProjectId?:  {
    __typename: "ModelLLMGroupConnection",
    items:  Array< {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMRouteRuleQueryVariables = {
  id: string,
};

export type GetLLMRouteRuleQuery = {
  getLLMRouteRule?:  {
    __typename: "LLMRouteRule",
    id: string,
    status: string,
    projectId: string,
    name?: string | null,
    pattern?: string | null,
    patternAction?: string | null,
    threshold?: number | null,
    thresholdAction?: string | null,
    groupId?: string | null,
    group?:  {
      __typename: "LLMGroup",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    order?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMRouteRulesQueryVariables = {
  filter?: ModelLLMRouteRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMRouteRulesQuery = {
  listLLMRouteRules?:  {
    __typename: "ModelLLMRouteRuleConnection",
    items:  Array< {
      __typename: "LLMRouteRule",
      id: string,
      status: string,
      projectId: string,
      name?: string | null,
      pattern?: string | null,
      patternAction?: string | null,
      threshold?: number | null,
      thresholdAction?: string | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type RouteRulesByProjectIdQueryVariables = {
  projectId: string,
  order?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMRouteRuleFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type RouteRulesByProjectIdQuery = {
  routeRulesByProjectId?:  {
    __typename: "ModelLLMRouteRuleConnection",
    items:  Array< {
      __typename: "LLMRouteRule",
      id: string,
      status: string,
      projectId: string,
      name?: string | null,
      pattern?: string | null,
      patternAction?: string | null,
      threshold?: number | null,
      thresholdAction?: string | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      order?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCustomerQueryVariables = {
  id: string,
};

export type GetLLMCustomerQuery = {
  getLLMCustomer?:  {
    __typename: "LLMCustomer",
    id: string,
    name?: string | null,
    status: string,
    tokensRemaining: number,
    lastCallMadeAt?: string | null,
    numberOfCallsMade?: number | null,
    projectId: string,
    loadSheddingTier: number,
    dataResidency: string,
    createdAt: string,
    enterpriseUser?: boolean | null,
    tokenReplenishmentAmount?: number | null,
    tokenReplenishmentPeriod?: string | null,
    lastReplenishedAt?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCustomersQueryVariables = {
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCustomersQuery = {
  listLLMCustomers?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndLastCallMadeAtQueryVariables = {
  projectId: string,
  lastCallMadeAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndLastCallMadeAtQuery = {
  customersByProjectIdAndLastCallMadeAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndCreatedAtQuery = {
  customersByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByProjectIdAndTokensRemainingQueryVariables = {
  projectId: string,
  tokensRemaining?: ModelIntKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByProjectIdAndTokensRemainingQuery = {
  customersByProjectIdAndTokensRemaining?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQueryVariables = {
  tokenReplenishmentPeriod: string,
  lastReplenishedAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCustomerFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQuery = {
  customersByTokenReplenishmentPeriodAndLastReplenishedAt?:  {
    __typename: "ModelLLMCustomerConnection",
    items:  Array< {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCallQueryVariables = {
  id: string,
};

export type GetLLMCallQuery = {
  getLLMCall?:  {
    __typename: "LLMCall",
    id: string,
    projectId: string,
    status: string,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    serviceId?: string | null,
    service?:  {
      __typename: "LLMService",
      id: string,
      name: string,
      status: string,
      vendor: string,
      region: string,
      endpoint?: string | null,
      body?: string | null,
      header?: string | null,
      projectId: string,
      loadProportion?: number | null,
      inputTokenPricePerMillion?: number | null,
      outputTokenPricePerMillion?: number | null,
      groupId?: string | null,
      group?:  {
        __typename: "LLMGroup",
        id: string,
        status: string,
        name: string,
        description?: string | null,
        projectId: string,
        systemInstructions?: string | null,
        systemInstructionsAction?: string | null,
        order?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      createdAt: string,
      updatedAt: string,
    } | null,
    requestHash?: string | null,
    messages?: string | null,
    prompt?: string | null,
    response?: string | null,
    tokenCountPrompt?: number | null,
    tokenCountResponse?: number | null,
    createdAt: string,
    hash?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    quality?: number | null,
    qualityComment?: string | null,
    apiKeyType?: string | null,
    toxicity?: string | null,
    randomGroup?: number | null,
    agentId?: string | null,
    conversationId?: string | null,
    timings?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCallsQueryVariables = {
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCallsQuery = {
  listLLMCalls?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByProjectIdAndCreatedAtQuery = {
  callsByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByHashAndCreatedAtQueryVariables = {
  hash: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByHashAndCreatedAtQuery = {
  callsByHashAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByRandomGroupAndCreatedAtQueryVariables = {
  randomGroup: number,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByRandomGroupAndCreatedAtQuery = {
  callsByRandomGroupAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByAgentIdAndCreatedAtQueryVariables = {
  agentId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByAgentIdAndCreatedAtQuery = {
  callsByAgentIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallsByConversationIdAndCreatedAtQueryVariables = {
  conversationId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallsByConversationIdAndCreatedAtQuery = {
  callsByConversationIdAndCreatedAt?:  {
    __typename: "ModelLLMCallConnection",
    items:  Array< {
      __typename: "LLMCall",
      id: string,
      projectId: string,
      status: string,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      serviceId?: string | null,
      service?:  {
        __typename: "LLMService",
        id: string,
        name: string,
        status: string,
        vendor: string,
        region: string,
        endpoint?: string | null,
        body?: string | null,
        header?: string | null,
        projectId: string,
        loadProportion?: number | null,
        inputTokenPricePerMillion?: number | null,
        outputTokenPricePerMillion?: number | null,
        groupId?: string | null,
        group?:  {
          __typename: "LLMGroup",
          id: string,
          status: string,
          name: string,
          description?: string | null,
          projectId: string,
          systemInstructions?: string | null,
          systemInstructionsAction?: string | null,
          order?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        createdAt: string,
        updatedAt: string,
      } | null,
      requestHash?: string | null,
      messages?: string | null,
      prompt?: string | null,
      response?: string | null,
      tokenCountPrompt?: number | null,
      tokenCountResponse?: number | null,
      createdAt: string,
      hash?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      quality?: number | null,
      qualityComment?: string | null,
      apiKeyType?: string | null,
      toxicity?: string | null,
      randomGroup?: number | null,
      agentId?: string | null,
      conversationId?: string | null,
      timings?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMPromptQueryVariables = {
  id: string,
};

export type GetLLMPromptQuery = {
  getLLMPrompt?:  {
    __typename: "LLMPrompt",
    id: string,
    projectId: string,
    status: string,
    name: string,
    description?: string | null,
    prompt?: string | null,
    key: string,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMPromptsQueryVariables = {
  filter?: ModelLLMPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMPromptsQuery = {
  listLLMPrompts?:  {
    __typename: "ModelLLMPromptConnection",
    items:  Array< {
      __typename: "LLMPrompt",
      id: string,
      projectId: string,
      status: string,
      name: string,
      description?: string | null,
      prompt?: string | null,
      key: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type PromptsByProjectIdAndKeyQueryVariables = {
  projectId: string,
  key?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMPromptFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type PromptsByProjectIdAndKeyQuery = {
  promptsByProjectIdAndKey?:  {
    __typename: "ModelLLMPromptConnection",
    items:  Array< {
      __typename: "LLMPrompt",
      id: string,
      projectId: string,
      status: string,
      name: string,
      description?: string | null,
      prompt?: string | null,
      key: string,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMCallLogFileQueryVariables = {
  id: string,
};

export type GetLLMCallLogFileQuery = {
  getLLMCallLogFile?:  {
    __typename: "LLMCallLogFile",
    id: string,
    projectId: string,
    fromDate?: string | null,
    toDate?: string | null,
    chunk?: number | null,
    count?: number | null,
    status: string,
    bucket: string,
    key: string,
    url?: string | null,
    urlExpiresAt?: string | null,
    deleteFileAfter?: string | null,
    createdAt: string,
    randomGroup?: number | null,
    updatedAt: string,
  } | null,
};

export type ListLLMCallLogFilesQueryVariables = {
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMCallLogFilesQuery = {
  listLLMCallLogFiles?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallLogFilesByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallLogFilesByProjectIdAndCreatedAtQuery = {
  callLogFilesByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type CallLogFilesByRandomGroupAndDeleteFileAfterQueryVariables = {
  randomGroup: number,
  deleteFileAfter?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMCallLogFileFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type CallLogFilesByRandomGroupAndDeleteFileAfterQuery = {
  callLogFilesByRandomGroupAndDeleteFileAfter?:  {
    __typename: "ModelLLMCallLogFileConnection",
    items:  Array< {
      __typename: "LLMCallLogFile",
      id: string,
      projectId: string,
      fromDate?: string | null,
      toDate?: string | null,
      chunk?: number | null,
      count?: number | null,
      status: string,
      bucket: string,
      key: string,
      url?: string | null,
      urlExpiresAt?: string | null,
      deleteFileAfter?: string | null,
      createdAt: string,
      randomGroup?: number | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentQueryVariables = {
  id: string,
};

export type GetLLMAgentQuery = {
  getLLMAgent?:  {
    __typename: "LLMAgent",
    id: string,
    status: string,
    name: string,
    description?: string | null,
    projectId: string,
    systemInstructions?: string | null,
    systemInstructionsAction?: string | null,
    displayTheme?: string | null,
    cssUrl?: string | null,
    displayTitle?: string | null,
    displayStartMessageOrPrompt?: string | null,
    displayInitialMessageOrPrompt?: string | null,
    displayPromptTemplate?: string | null,
    displayFollowOnPrompts?: string | null,
    displayActions?: string | null,
    displayWidth?: string | null,
    displayHeight?: string | null,
    displayPlaceholder?: string | null,
    displayHideInitialPrompt?: boolean | null,
    displayShowSaveButton?: boolean | null,
    displayShowEmailButton?: boolean | null,
    displayShowCallToAction?: boolean | null,
    displayCallToActionButtonText?: string | null,
    displayCallToActionEmailAddress?: string | null,
    displayCallToActionEmailSubject?: string | null,
    displayCallToActionMustSendEmail?: boolean | null,
    displayScrollToEnd?: boolean | null,
    groupId?: string | null,
    data?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    documents?:  {
      __typename: "ModelLLMAgentDocumentConnection",
      items:  Array< {
        __typename: "LLMAgentDocument",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        fileName?: string | null,
        fileSize?: string | null,
        fileType?: string | null,
        uploadDate?: string | null,
        uploader?: string | null,
        lastModifiedDate?: string | null,
        ownershipAttestation?: string | null,
        location?: string | null,
        type?: string | null,
        ragSplitter?: string | null,
        ragChunkSize?: number | null,
        ragChunkOverlap?: number | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    mcpServers?:  {
      __typename: "ModelLLMAgentMCPConnection",
      items:  Array< {
        __typename: "LLMAgentMCP",
        id: string,
        projectId: string,
        agentId: string,
        status: string,
        transport?: LLMMCPTransport | null,
        sseUrl?: string | null,
        sseHeaders?: string | null,
        stdioCommand?: string | null,
        stdioArgs?: string | null,
        createdAt: string,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    ragQueryLimit?: number | null,
    ragRankLimit?: number | null,
    ragIncludeCitations?: boolean | null,
    ragDoRerank?: boolean | null,
    visibility?: LLMVisibility | null,
    createConversationOnFirstChat?: boolean | null,
    customerEmailCaptureMode?: LLMEmailCaptureMode | null,
    customerEmailCapturePlaceholder?: string | null,
    enableRAG?: boolean | null,
    enableMCP?: boolean | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentsQueryVariables = {
  filter?: ModelLLMAgentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentsQuery = {
  listLLMAgents?:  {
    __typename: "ModelLLMAgentConnection",
    items:  Array< {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          transport?: LLMMCPTransport | null,
          sseUrl?: string | null,
          sseHeaders?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentsByProjectIdQuery = {
  agentsByProjectId?:  {
    __typename: "ModelLLMAgentConnection",
    items:  Array< {
      __typename: "LLMAgent",
      id: string,
      status: string,
      name: string,
      description?: string | null,
      projectId: string,
      systemInstructions?: string | null,
      systemInstructionsAction?: string | null,
      displayTheme?: string | null,
      cssUrl?: string | null,
      displayTitle?: string | null,
      displayStartMessageOrPrompt?: string | null,
      displayInitialMessageOrPrompt?: string | null,
      displayPromptTemplate?: string | null,
      displayFollowOnPrompts?: string | null,
      displayActions?: string | null,
      displayWidth?: string | null,
      displayHeight?: string | null,
      displayPlaceholder?: string | null,
      displayHideInitialPrompt?: boolean | null,
      displayShowSaveButton?: boolean | null,
      displayShowEmailButton?: boolean | null,
      displayShowCallToAction?: boolean | null,
      displayCallToActionButtonText?: string | null,
      displayCallToActionEmailAddress?: string | null,
      displayCallToActionEmailSubject?: string | null,
      displayCallToActionMustSendEmail?: boolean | null,
      displayScrollToEnd?: boolean | null,
      groupId?: string | null,
      data?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      documents?:  {
        __typename: "ModelLLMAgentDocumentConnection",
        items:  Array< {
          __typename: "LLMAgentDocument",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          fileName?: string | null,
          fileSize?: string | null,
          fileType?: string | null,
          uploadDate?: string | null,
          uploader?: string | null,
          lastModifiedDate?: string | null,
          ownershipAttestation?: string | null,
          location?: string | null,
          type?: string | null,
          ragSplitter?: string | null,
          ragChunkSize?: number | null,
          ragChunkOverlap?: number | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      mcpServers?:  {
        __typename: "ModelLLMAgentMCPConnection",
        items:  Array< {
          __typename: "LLMAgentMCP",
          id: string,
          projectId: string,
          agentId: string,
          status: string,
          transport?: LLMMCPTransport | null,
          sseUrl?: string | null,
          sseHeaders?: string | null,
          stdioCommand?: string | null,
          stdioArgs?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      ragQueryLimit?: number | null,
      ragRankLimit?: number | null,
      ragIncludeCitations?: boolean | null,
      ragDoRerank?: boolean | null,
      visibility?: LLMVisibility | null,
      createConversationOnFirstChat?: boolean | null,
      customerEmailCaptureMode?: LLMEmailCaptureMode | null,
      customerEmailCapturePlaceholder?: string | null,
      enableRAG?: boolean | null,
      enableMCP?: boolean | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentMCPQueryVariables = {
  id: string,
};

export type GetLLMAgentMCPQuery = {
  getLLMAgentMCP?:  {
    __typename: "LLMAgentMCP",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    transport?: LLMMCPTransport | null,
    sseUrl?: string | null,
    sseHeaders?: string | null,
    stdioCommand?: string | null,
    stdioArgs?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentMCPSQueryVariables = {
  filter?: ModelLLMAgentMCPFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentMCPSQuery = {
  listLLMAgentMCPS?:  {
    __typename: "ModelLLMAgentMCPConnection",
    items:  Array< {
      __typename: "LLMAgentMCP",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      transport?: LLMMCPTransport | null,
      sseUrl?: string | null,
      sseHeaders?: string | null,
      stdioCommand?: string | null,
      stdioArgs?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentMCPByAgentIdQueryVariables = {
  agentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentMCPFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentMCPByAgentIdQuery = {
  agentMCPByAgentId?:  {
    __typename: "ModelLLMAgentMCPConnection",
    items:  Array< {
      __typename: "LLMAgentMCP",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      transport?: LLMMCPTransport | null,
      sseUrl?: string | null,
      sseHeaders?: string | null,
      stdioCommand?: string | null,
      stdioArgs?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMAgentDocumentQueryVariables = {
  id: string,
};

export type GetLLMAgentDocumentQuery = {
  getLLMAgentDocument?:  {
    __typename: "LLMAgentDocument",
    id: string,
    projectId: string,
    agentId: string,
    status: string,
    fileName?: string | null,
    fileSize?: string | null,
    fileType?: string | null,
    uploadDate?: string | null,
    uploader?: string | null,
    lastModifiedDate?: string | null,
    ownershipAttestation?: string | null,
    location?: string | null,
    type?: string | null,
    ragSplitter?: string | null,
    ragChunkSize?: number | null,
    ragChunkOverlap?: number | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMAgentDocumentsQueryVariables = {
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMAgentDocumentsQuery = {
  listLLMAgentDocuments?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentDocumentsByProjectIdQueryVariables = {
  projectId: string,
  status?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentDocumentsByProjectIdQuery = {
  agentDocumentsByProjectId?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type AgentDocumentsByAgentIdQueryVariables = {
  agentId: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMAgentDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type AgentDocumentsByAgentIdQuery = {
  agentDocumentsByAgentId?:  {
    __typename: "ModelLLMAgentDocumentConnection",
    items:  Array< {
      __typename: "LLMAgentDocument",
      id: string,
      projectId: string,
      agentId: string,
      status: string,
      fileName?: string | null,
      fileSize?: string | null,
      fileType?: string | null,
      uploadDate?: string | null,
      uploader?: string | null,
      lastModifiedDate?: string | null,
      ownershipAttestation?: string | null,
      location?: string | null,
      type?: string | null,
      ragSplitter?: string | null,
      ragChunkSize?: number | null,
      ragChunkOverlap?: number | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMConversationQueryVariables = {
  id: string,
};

export type GetLLMConversationQuery = {
  getLLMConversation?:  {
    __typename: "LLMConversation",
    id: string,
    projectId: string,
    agentId?: string | null,
    customerId?: string | null,
    customer?:  {
      __typename: "LLMCustomer",
      id: string,
      name?: string | null,
      status: string,
      tokensRemaining: number,
      lastCallMadeAt?: string | null,
      numberOfCallsMade?: number | null,
      projectId: string,
      loadSheddingTier: number,
      dataResidency: string,
      createdAt: string,
      enterpriseUser?: boolean | null,
      tokenReplenishmentAmount?: number | null,
      tokenReplenishmentPeriod?: string | null,
      lastReplenishedAt?: string | null,
      updatedAt: string,
    } | null,
    createdAt: string,
    status: string,
    title: string,
    summary?: string | null,
    timezone?: string | null,
    language?: string | null,
    country?: string | null,
    region?: string | null,
    city?: string | null,
    calls?:  {
      __typename: "ModelLLMCallConnection",
      items:  Array< {
        __typename: "LLMCall",
        id: string,
        projectId: string,
        status: string,
        customerId?: string | null,
        customer?:  {
          __typename: "LLMCustomer",
          id: string,
          name?: string | null,
          status: string,
          tokensRemaining: number,
          lastCallMadeAt?: string | null,
          numberOfCallsMade?: number | null,
          projectId: string,
          loadSheddingTier: number,
          dataResidency: string,
          createdAt: string,
          enterpriseUser?: boolean | null,
          tokenReplenishmentAmount?: number | null,
          tokenReplenishmentPeriod?: string | null,
          lastReplenishedAt?: string | null,
          updatedAt: string,
        } | null,
        serviceId?: string | null,
        service?:  {
          __typename: "LLMService",
          id: string,
          name: string,
          status: string,
          vendor: string,
          region: string,
          endpoint?: string | null,
          body?: string | null,
          header?: string | null,
          projectId: string,
          loadProportion?: number | null,
          inputTokenPricePerMillion?: number | null,
          outputTokenPricePerMillion?: number | null,
          groupId?: string | null,
          createdAt: string,
          updatedAt: string,
        } | null,
        requestHash?: string | null,
        messages?: string | null,
        prompt?: string | null,
        response?: string | null,
        tokenCountPrompt?: number | null,
        tokenCountResponse?: number | null,
        createdAt: string,
        hash?: string | null,
        country?: string | null,
        region?: string | null,
        city?: string | null,
        quality?: number | null,
        qualityComment?: string | null,
        apiKeyType?: string | null,
        toxicity?: string | null,
        randomGroup?: number | null,
        agentId?: string | null,
        conversationId?: string | null,
        timings?: string | null,
        updatedAt: string,
      } | null >,
      nextToken?: string | null,
    } | null,
    emailAddress?: string | null,
    thumbsupClicked?: number | null,
    thumbsdownClicked?: number | null,
    copyClicked?: number | null,
    emailClicked?: number | null,
    saveClicked?: number | null,
    ctaClicked?: number | null,
    suggestionClicked?: number | null,
    actionClicked?: number | null,
    intelligence?: string | null,
    updatedAt: string,
  } | null,
};

export type ListLLMConversationsQueryVariables = {
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMConversationsQuery = {
  listLLMConversations?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ConversationsByProjectIdAndCreatedAtQueryVariables = {
  projectId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ConversationsByProjectIdAndCreatedAtQuery = {
  conversationsByProjectIdAndCreatedAt?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type ConversationsByCustomerIdAndCreatedAtQueryVariables = {
  customerId: string,
  createdAt?: ModelStringKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelLLMConversationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ConversationsByCustomerIdAndCreatedAtQuery = {
  conversationsByCustomerIdAndCreatedAt?:  {
    __typename: "ModelLLMConversationConnection",
    items:  Array< {
      __typename: "LLMConversation",
      id: string,
      projectId: string,
      agentId?: string | null,
      customerId?: string | null,
      customer?:  {
        __typename: "LLMCustomer",
        id: string,
        name?: string | null,
        status: string,
        tokensRemaining: number,
        lastCallMadeAt?: string | null,
        numberOfCallsMade?: number | null,
        projectId: string,
        loadSheddingTier: number,
        dataResidency: string,
        createdAt: string,
        enterpriseUser?: boolean | null,
        tokenReplenishmentAmount?: number | null,
        tokenReplenishmentPeriod?: string | null,
        lastReplenishedAt?: string | null,
        updatedAt: string,
      } | null,
      createdAt: string,
      status: string,
      title: string,
      summary?: string | null,
      timezone?: string | null,
      language?: string | null,
      country?: string | null,
      region?: string | null,
      city?: string | null,
      calls?:  {
        __typename: "ModelLLMCallConnection",
        items:  Array< {
          __typename: "LLMCall",
          id: string,
          projectId: string,
          status: string,
          customerId?: string | null,
          serviceId?: string | null,
          requestHash?: string | null,
          messages?: string | null,
          prompt?: string | null,
          response?: string | null,
          tokenCountPrompt?: number | null,
          tokenCountResponse?: number | null,
          createdAt: string,
          hash?: string | null,
          country?: string | null,
          region?: string | null,
          city?: string | null,
          quality?: number | null,
          qualityComment?: string | null,
          apiKeyType?: string | null,
          toxicity?: string | null,
          randomGroup?: number | null,
          agentId?: string | null,
          conversationId?: string | null,
          timings?: string | null,
          updatedAt: string,
        } | null >,
        nextToken?: string | null,
      } | null,
      emailAddress?: string | null,
      thumbsupClicked?: number | null,
      thumbsdownClicked?: number | null,
      copyClicked?: number | null,
      emailClicked?: number | null,
      saveClicked?: number | null,
      ctaClicked?: number | null,
      suggestionClicked?: number | null,
      actionClicked?: number | null,
      intelligence?: string | null,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};

export type GetLLMModelQueryVariables = {
  id: string,
};

export type GetLLMModelQuery = {
  getLLMModel?:  {
    __typename: "LLMModel",
    id: string,
    status: string,
    vendor: string,
    host?: string | null,
    supported: boolean,
    name: string,
    description?: string | null,
    modelKey?: string | null,
    modelKeyLatest?: string | null,
    inputTokenPrice?: number | null,
    cachedTokenPrice?: number | null,
    outputTokenPrice?: number | null,
    inputTokenBatchPrice?: number | null,
    outputTokenBatchPrice?: number | null,
    searchCost?: number | null,
    textInputSupport?: boolean | null,
    imageInputSupport?: boolean | null,
    audioInputSupport?: boolean | null,
    textOutputSupport?: boolean | null,
    imageOutputSupport?: boolean | null,
    audioOutputSupport?: boolean | null,
    thinkingSupport?: boolean | null,
    contextWindowTokens?: number | null,
    maxResponseTokens?: number | null,
    knowledgeCutoffDate?: string | null,
    lastCheckedDate?: string | null,
    supportedLanguages?: string | null,
    warningDate?: string | null,
    warningMessage?: string | null,
    deprecationDate?: string | null,
    deprecationMessage?: string | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListLLMModelsQueryVariables = {
  filter?: ModelLLMModelFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListLLMModelsQuery = {
  listLLMModels?:  {
    __typename: "ModelLLMModelConnection",
    items:  Array< {
      __typename: "LLMModel",
      id: string,
      status: string,
      vendor: string,
      host?: string | null,
      supported: boolean,
      name: string,
      description?: string | null,
      modelKey?: string | null,
      modelKeyLatest?: string | null,
      inputTokenPrice?: number | null,
      cachedTokenPrice?: number | null,
      outputTokenPrice?: number | null,
      inputTokenBatchPrice?: number | null,
      outputTokenBatchPrice?: number | null,
      searchCost?: number | null,
      textInputSupport?: boolean | null,
      imageInputSupport?: boolean | null,
      audioInputSupport?: boolean | null,
      textOutputSupport?: boolean | null,
      imageOutputSupport?: boolean | null,
      audioOutputSupport?: boolean | null,
      thinkingSupport?: boolean | null,
      contextWindowTokens?: number | null,
      maxResponseTokens?: number | null,
      knowledgeCutoffDate?: string | null,
      lastCheckedDate?: string | null,
      supportedLanguages?: string | null,
      warningDate?: string | null,
      warningMessage?: string | null,
      deprecationDate?: string | null,
      deprecationMessage?: string | null,
      createdAt: string,
      updatedAt: string,
    } | null >,
    nextToken?: string | null,
  } | null,
};
